import { z } from "zod";

export const groupMembersQuerySchema = z.object({
	page: z.coerce.number().int().min(1).default(1),
	limit: z.coerce.number().int().min(1).max(50).default(20),
	q: z.preprocess((value) => (typeof value === "string" && value.trim() === "" ? undefined : value), z.string().trim().max(100).optional()),
});

export type GroupMembersQueryPayload = z.infer<typeof groupMembersQuerySchema>;
